import { Adapter as t } from "../../../../../adapter.js";
import { AdyenGPayPaymentMethod as a } from "./adyenGPayPaymentMethod.model.js";
class c extends t {
  adapt(n) {
    return new a({
      brands: n.brands,
      name: n.name,
      type: n.type,
      configuration: {
        merchantId: n.configuration.merchant_id,
        merchantName: n.configuration.merchant_name,
        gatewayMerchantId: n.configuration.gateway_merchant_id,
        merchantOrigin: n.configuration.merchant_origin,
        authJwt: n.configuration.auth_jwt
      }
    });
  }
  serialize(n) {
    return {
      brands: n.brands,
      name: n.name,
      type: n.type,
      configuration: {
        merchant_id: n.configuration.merchantId,
        merchant_name: n.configuration.merchantName,
        gateway_merchant_id: n.configuration.gatewayMerchantId,
        merchant_origin: n.configuration.merchantOrigin,
        auth_jwt: n.configuration.authJwt
      }
    };
  }
}
export {
  c as AdyenGPayPaymentMethodAdapter
};
//# sourceMappingURL=adyenGPayPaymentMethod.adapter.js.map
